var Config = {
    production: {
        apiUrl: process.env.REACT_APP_CARD_API_URL,
        mixpanelToken: process.env.REACT_APP_MIXPANEL_TOKEN,
        appId: process.env.REACT_APP_APP_ID,
        appSecret: process.env.REACT_APP_APP_SECRET,
        authUrl: process.env.REACT_APP_AUTH_URL,
        platformUrl: process.env.REACT_APP_PLATFORM_API_URL,
        cardUrl: 'https://card.increase.app'
    },
    staging: {
        apiUrl: process.env.REACT_APP_CARD_API_URL,
        mixpanelToken: process.env.REACT_APP_MIXPANEL_TOKEN,
        appId: process.env.REACT_APP_APP_ID,
        appSecret: process.env.REACT_APP_APP_SECRET,
        authUrl: process.env.REACT_APP_AUTH_URL,
        platformUrl: process.env.REACT_APP_PLATFORM_API_URL,
        cardUrl: 'https://card.staging.increase.app'
    },
    dev: {
        apiUrl: process.env.REACT_APP_CARD_API_URL,
        mixpanelToken: process.env.REACT_APP_MIXPANEL_TOKEN,
        appId: process.env.REACT_APP_APP_ID,
        appSecret: process.env.REACT_APP_APP_SECRET,
        authUrl: process.env.REACT_APP_AUTH_URL,
        platformUrl: process.env.REACT_APP_PLATFORM_API_URL,
        cardUrl: 'https://card.staging.increase.app'
    }
};
export default Config[process.env.REACT_APP_STAGE || 'staging'];
